webpackJsonp([94],{

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);





var filters = {
  formatGrade: function formatGrade(val) {
    var value = '';
    var types = [{ v: 'junior', t: '初级教练' }, { v: 'medium', t: '中级教练' }, { v: 'senior', t: '高级教练' }, { v: 'international', t: '国际教练' }];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(types.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var el = _ref2[1];

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default()(val, el.v)) {
          value = el.t;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return value;
  },
  formatActivity: function formatActivity(val) {
    var value = '';
    var types = [{ v: '1', t: '进行中' }, { v: '2', t: '报名截止' }, { v: '3', t: '报名中' }, { v: '4', t: '已报满' }, { v: '5', t: '已结束' }];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(types.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _ref3 = _step2.value;

        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

        var el = _ref4[1];

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default()(val, el.v)) {
          value = el.t;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return value;
  },
  formatSignType: function formatSignType(val, num, t) {
    if (val === '1' && t === '元') {
      return num.toFixed(2) + t;
    } else if (val === '1' || val === '金额' || val === '元' || val === '免费') {
      return '￥' + num.toFixed(2);
    } else if (val === '2' || val === '积分') {
      return num + ' 积分';
    } else if (val === '3' || val === '基础课节') {
      return num.toFixed(2) + ' 基础课节';
    } else {
      return '';
    }
  },
  formatTime: function formatTime(val) {
    var day = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD');
    var time = __WEBPACK_IMPORTED_MODULE_4_moment___default()(day);
    if (__WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(val)) < 1000 * 60 * 10 && __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(val)) > 0) {
      // 当前时间10分钟之前
      return '刚刚';
    } else if (time.diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(val)) < 0) {
      // 今天
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('HH:mm');
    } else if (time.diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(val)) < 1000 * 60 * 60 * 24) {
      // 昨天
      return '昨天' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('HH:mm');
    } else if (time.diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(val)) < 1000 * 60 * 60 * 24 * 2) {
      // 前天
      return '前天' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('HH:mm');
    } else {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('MM/DD HH:mm');
    }
  },
  formatOrderType: function formatOrderType(val) {
    if (val === 'curse' || val === '课' || val === '期课') {
      return '课程票';
    } else if (val === 'courseExperience' || val === '体验课') {
      return '体验课';
    } else if (val === '时段票实例') {
      return '时段票';
    } else if (val === '单次票实例') {
      return '单次票';
    } else if (val === '练习票实例') {
      return '练习票';
    } else if (val === '陪同票实例') {
      return '陪同票';
    } else if (val === '活动') {
      return '活动';
    } else if (val === '课程卡') {
      return '课程卡';
    } else {
      return '商品订单';
    }
  },
  formatDate: function formatDate(val) {
    return val ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('YYYY.MM.DD') : '';
  },
  formatCouponStatus: function formatCouponStatus(val) {
    var value = '';
    var types = [{ v: 'unused', t: '可使用' }, { v: 'used', t: '已使用' }, { v: 'expired', t: '已过期' }, { v: 'invalid', t: '已失效' }];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(types.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _ref5 = _step3.value;

        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

        var el = _ref6[1];

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default()(val, el.v)) {
          value = el.t;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return value;
  }
};
for (var key in filters) {
  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter(key, filters[key]);
}

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_url__ = __webpack_require__(9);

/**
 * Created by Administrator on 2017/6/26 0026.
 */
// import axios from 'axios'

var wx = __webpack_require__(40);
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var wechat = Vue.wechat = Vue.prototype.$wechat = {};
    //    注入微信权限认证
    wechat.config = function (ops) {
      var config = {
        debug: false,
        appId: ops.appId,
        timestamp: ops.timeStamp,
        nonceStr: ops.nonceStr,
        signature: ops.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'chooseWXPay', 'getLocation']
      };
      wx.config(config);
    };
    wechat.pay = function (data) {
      var config = {
        timestamp: data.timeStamp + '',
        nonceStr: data.nonceStr,
        package: data.package,
        signType: 'MD5',
        paySign: data.paySign,
        success: function success(res) {
          console.log(res);
          // 根据actP参数判断需要跳转至那个页面
          var actP = sessionStorage.getItem('actP');
          if (actP === '' || actP === 'null') {
            // 跳转到我的订单页面
            location.href = __WEBPACK_IMPORTED_MODULE_1__common_js_url__["a" /* default */].api + 'wechat/index.html#/note/once';
          } else if (actP === 'inline') {
            // 跳转到报名详情
            location.href = __WEBPACK_IMPORTED_MODULE_1__common_js_url__["a" /* default */].api + 'wechat/index.html#/regisDetail/' + sessionStorage.getItem('eventId') + '/' + sessionStorage.getItem('eventUserId');
          } else if (actP === 'out') {
            // 跳转到购买详情
            location.href = __WEBPACK_IMPORTED_MODULE_1__common_js_url__["a" /* default */].api + 'wechat/index.html#/shopDetail/' + sessionStorage.getItem('eventId');
          }
        },
        error: function error(res) {
          alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
        }
      };
      wx.chooseWXPay(config);
    };
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(284);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    showLimitDialog: false,
    showExperience: true
  },
  mutations: {
    changeLimitDialog: function changeLimitDialog(state, show) {
      state.showLimitDialog = show;
    },
    closeExperience: function closeExperience(state, show) {
      state.showExperience = show;
    }
  }
}));

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(281),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_url_js__ = __webpack_require__(9);
/**
 * Created by Administrator on 2017/7/6 0006.
 */

var filter = /\/\?[^\s]*#\//;

var login = function login(scope) {
  // sessionStorage.removeItem(GLOBAL_CONFIG.TOKEN_NAME);
  var locationUrl = __WEBPACK_IMPORTED_MODULE_0__common_js_url_js__["a" /* default */].login_url + '?redirect=' + encodeURIComponent(location.href.replace(filter, '/#/'));
  locationUrl += '&oauth_scope=' + (scope || 'BASE');
  console.log(locationUrl);
  // location.href = (locationUrl)
};

/* harmony default export */ __webpack_exports__["a"] = ({
  login: login
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_wechat_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_url_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js_utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_js_filter_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_spinner_style_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_spinner_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_spinner_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_toast_style_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_toast_style_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// import Vconsole from 'vconsole'




/* eslint-disable no-new */

/* --------- */
// let vconsole = new Vconsole()
// export default vconsole
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__common_js_wechat_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_mint_ui___default.a);

// 处理微信分享出来的地址，微信会添加多余参数
function getCorrectUrl() {
  var baseUrl = __WEBPACK_IMPORTED_MODULE_8__common_js_url_js__["a" /* default */].api + 'wechat/index.html';
  var originUrl = window.location.href;
  var redirectUrl = originUrl.split('#/')[1];
  return baseUrl + '#/' + redirectUrl;
}

var deviceId = localStorage.getItem('deviceId');
if (!deviceId) {
  deviceId = 'device_' + Math.random().toString().replace('.', '');
  localStorage.setItem("deviceId", deviceId);
}

// 微信授权
var redirectLogin = function redirectLogin() {
  sessionStorage.removeItem('openId');
  var loginUrl = __WEBPACK_IMPORTED_MODULE_8__common_js_url_js__["a" /* default */].api + 'memberapi/wx/auth/initOpenId.do?from=' + from + '&redirectUrl=' + redirectUrl + '&actP=' + actP + '&userAgent=' + encodeURIComponent(navigator.userAgent) + '&deviceId=' + deviceId;
  location.replace(loginUrl);
};
var redirectUrl = location.href.indexOf('from') > -1 ? location.href.split('?from')[0].replace('#', '%23') : location.href.replace('#', '%23');
// 获取openId
var openId = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'openId');

// 获取authtoken
var authToken = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'authtoken');

// 获取用户登录状态
var wxUserStatus = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'status');
sessionStorage.setItem('wxUserStatus', wxUserStatus);

// 如果没有门店ID，从地址栏获取，如果已经存储了门店Id，则不需要
if (!sessionStorage.getItem('storeId') || sessionStorage.getItem('storeId') === 'null') {
  var storeId = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'storeId');
  sessionStorage.setItem('storeId', storeId);
}
// 获取来自哪个公众号
var from = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'from');
if (sessionStorage.getItem('from') === '' || sessionStorage.getItem('from') === null) {
  sessionStorage.setItem('from', from);
}
// 区分活动页面是是从公众号直接打开还是从外部链接打开，需要手动在连接后面配置actP参数
// actP='inline' 则为公众号进入 actP='out' 则为外部进入
var actP = __WEBPACK_IMPORTED_MODULE_9__common_js_utils__["a" /* default */].GetQueryString('?' + location.hash.split('?')[1], 'actP');
if (sessionStorage.getItem('actP') === '' || sessionStorage.getItem('actP') === null) {
  sessionStorage.setItem('actP', actP);
}
// 设置测试环境token，部署到测试、生产需要注释
//sessionStorage.setItem('authtoken', 'oX2Rs05IZoZKnIq4fxpIh47ZHmcM')
//sessionStorage.setItem('storeId', '1')
//sessionStorage.setItem('wxUserStatus', '2')

// 设置测试环境token，部署到测试、生产需要注释
if (false) {
  if (!sessionStorage.getItem('authtoken')) {
    authToken = '654321';
  } else {
    authToken = sessionStorage.getItem('authtoken');
  }
  if (!openId) {
    openId = '123456';
  }
}

// axios过滤器
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.request.use(function (config) {
  // Do something before request is sent
  // 设置基础参数
  if (config.params) {
    config.params.storeId = sessionStorage.getItem('storeId');
    config.params.appVersion = '1.0';
    config.params.imei = '';
    config.params.osVersion = '';
    config.params.platform = 'weixin';
  }
  if (sessionStorage.getItem('authtoken') && sessionStorage.getItem('authtoken') !== 'null') {
    config.headers['authtoken'] = sessionStorage.getItem('authtoken');
  }
  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

//  切换路由需要更新重新验证config配置
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (route) {
  if (route.meta.title) {
    document.title = route.meta.title; // 设置文档标题
  }
  var configUrl = location.href.split('#')[0];
  __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__common_js_url_js__["a" /* default */].api + 'payapi/wx/config.do', {
    params: {
      storeId: sessionStorage.getItem('storeId'),
      configUrl: encodeURIComponent(configUrl)
    }
  }).then(function (res) {
    var data = res.data;
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].wechat.config(data);
  }).catch(function () {});
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  var wxUserStatus = sessionStorage.getItem('wxUserStatus');
  // 需要判断wxUserStatus的页面
  var needLoginRouteList = ['/order/all', '/mine', '/coupon/gift', '/myNewActivity', '/rights', '/myCourse/open', '/note/course', '/getCoupon/1'];
  // console.log('to:', to.path)
  if (needLoginRouteList.includes(to.path)) {
    if (wxUserStatus === '1') {
      next('/bind');
    } else if (wxUserStatus === '2') {
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});
// 生产环境判断
if (authToken || openId) {
  sessionStorage.setItem('authtoken', authToken);
  sessionStorage.setItem('openId', openId);
  new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_7__store_index_js__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: {
      App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
    }
  });
} else if (sessionStorage.getItem('authtoken') || sessionStorage.getItem('openId')) {
  new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_7__store_index_js__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: {
      App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
    }
  });
} else {
  if (window.location.href.indexOf('groupmessage') > -1 || window.location.href.indexOf('singlemessage') > -1 || window.location.href.indexOf('timeline') > -1) {
    // 微信分享出来的链接
    location.replace(getCorrectUrl());
  } else {
    redirectLogin();
  }
}

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_url_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_common__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_button_style_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_button_style_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  mounted: function mounted() {
    var locationUrl = location.href.split('?')[0];
    __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.ready(function () {
      __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.onMenuShareAppMessage({
        title: '测试',
        desc: '测试内容',
        link: locationUrl,
        imgUrl: 'https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1499307114&di=bb3fae16a21329b3ed8caabfa44a6a53&src=http://p.nanrenwo.net/uploads/allimg/170601/8467-1F601134222.jpg',
        type: '',
        dataUrl: '',
        success: function success() {},
        cancel: function cancel() {}
      });
      __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.onMenuShareTimeline({
        title: '朋友圈标题',
        link: locationUrl,
        imgUrl: 'https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1499307114&di=bb3fae16a21329b3ed8caabfa44a6a53&src=http://p.nanrenwo.net/uploads/allimg/170601/8467-1F601134222.jpg',
        success: function success() {},
        cancel: function cancel() {}
      });
    });
  },
  data: function data() {
    return {};
  },

  methods: {
    pay: function pay() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__common_js_url_js__["a" /* default */].api + 'payapi/wx/getprepayinfo.do', {
        params: {
          authtoken: 'F763FF54A8144C10AACB2B9FAD73C93F'
        }
      }).then(function (res) {
        that.$wechat.pay(res.data);
      });
    },
    authorize: function authorize() {
      __WEBPACK_IMPORTED_MODULE_2__common_js_common__["a" /* default */].login();
    }
  },
  components: {
    MtButton: __WEBPACK_IMPORTED_MODULE_4_mint_ui__["Button"]
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 58,
	"./af.js": 58,
	"./ar": 66,
	"./ar-dz": 59,
	"./ar-dz.js": 59,
	"./ar-kw": 60,
	"./ar-kw.js": 60,
	"./ar-ly": 61,
	"./ar-ly.js": 61,
	"./ar-ma": 62,
	"./ar-ma.js": 62,
	"./ar-ps": 63,
	"./ar-ps.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 66,
	"./az": 67,
	"./az.js": 67,
	"./be": 68,
	"./be.js": 68,
	"./bg": 69,
	"./bg.js": 69,
	"./bm": 70,
	"./bm.js": 70,
	"./bn": 72,
	"./bn-bd": 71,
	"./bn-bd.js": 71,
	"./bn.js": 72,
	"./bo": 73,
	"./bo.js": 73,
	"./br": 74,
	"./br.js": 74,
	"./bs": 75,
	"./bs.js": 75,
	"./ca": 76,
	"./ca.js": 76,
	"./cs": 77,
	"./cs.js": 77,
	"./cv": 78,
	"./cv.js": 78,
	"./cy": 79,
	"./cy.js": 79,
	"./da": 80,
	"./da.js": 80,
	"./de": 83,
	"./de-at": 81,
	"./de-at.js": 81,
	"./de-ch": 82,
	"./de-ch.js": 82,
	"./de.js": 83,
	"./dv": 84,
	"./dv.js": 84,
	"./el": 85,
	"./el.js": 85,
	"./en-au": 86,
	"./en-au.js": 86,
	"./en-ca": 87,
	"./en-ca.js": 87,
	"./en-gb": 88,
	"./en-gb.js": 88,
	"./en-ie": 89,
	"./en-ie.js": 89,
	"./en-il": 90,
	"./en-il.js": 90,
	"./en-in": 91,
	"./en-in.js": 91,
	"./en-nz": 92,
	"./en-nz.js": 92,
	"./en-sg": 93,
	"./en-sg.js": 93,
	"./eo": 94,
	"./eo.js": 94,
	"./es": 98,
	"./es-do": 95,
	"./es-do.js": 95,
	"./es-mx": 96,
	"./es-mx.js": 96,
	"./es-us": 97,
	"./es-us.js": 97,
	"./es.js": 98,
	"./et": 99,
	"./et.js": 99,
	"./eu": 100,
	"./eu.js": 100,
	"./fa": 101,
	"./fa.js": 101,
	"./fi": 102,
	"./fi.js": 102,
	"./fil": 103,
	"./fil.js": 103,
	"./fo": 104,
	"./fo.js": 104,
	"./fr": 107,
	"./fr-ca": 105,
	"./fr-ca.js": 105,
	"./fr-ch": 106,
	"./fr-ch.js": 106,
	"./fr.js": 107,
	"./fy": 108,
	"./fy.js": 108,
	"./ga": 109,
	"./ga.js": 109,
	"./gd": 110,
	"./gd.js": 110,
	"./gl": 111,
	"./gl.js": 111,
	"./gom-deva": 112,
	"./gom-deva.js": 112,
	"./gom-latn": 113,
	"./gom-latn.js": 113,
	"./gu": 114,
	"./gu.js": 114,
	"./he": 115,
	"./he.js": 115,
	"./hi": 116,
	"./hi.js": 116,
	"./hr": 117,
	"./hr.js": 117,
	"./hu": 118,
	"./hu.js": 118,
	"./hy-am": 119,
	"./hy-am.js": 119,
	"./id": 120,
	"./id.js": 120,
	"./is": 121,
	"./is.js": 121,
	"./it": 123,
	"./it-ch": 122,
	"./it-ch.js": 122,
	"./it.js": 123,
	"./ja": 124,
	"./ja.js": 124,
	"./jv": 125,
	"./jv.js": 125,
	"./ka": 126,
	"./ka.js": 126,
	"./kk": 127,
	"./kk.js": 127,
	"./km": 128,
	"./km.js": 128,
	"./kn": 129,
	"./kn.js": 129,
	"./ko": 130,
	"./ko.js": 130,
	"./ku": 132,
	"./ku-kmr": 131,
	"./ku-kmr.js": 131,
	"./ku.js": 132,
	"./ky": 133,
	"./ky.js": 133,
	"./lb": 134,
	"./lb.js": 134,
	"./lo": 135,
	"./lo.js": 135,
	"./lt": 136,
	"./lt.js": 136,
	"./lv": 137,
	"./lv.js": 137,
	"./me": 138,
	"./me.js": 138,
	"./mi": 139,
	"./mi.js": 139,
	"./mk": 140,
	"./mk.js": 140,
	"./ml": 141,
	"./ml.js": 141,
	"./mn": 142,
	"./mn.js": 142,
	"./mr": 143,
	"./mr.js": 143,
	"./ms": 145,
	"./ms-my": 144,
	"./ms-my.js": 144,
	"./ms.js": 145,
	"./mt": 146,
	"./mt.js": 146,
	"./my": 147,
	"./my.js": 147,
	"./nb": 148,
	"./nb.js": 148,
	"./ne": 149,
	"./ne.js": 149,
	"./nl": 151,
	"./nl-be": 150,
	"./nl-be.js": 150,
	"./nl.js": 151,
	"./nn": 152,
	"./nn.js": 152,
	"./oc-lnc": 153,
	"./oc-lnc.js": 153,
	"./pa-in": 154,
	"./pa-in.js": 154,
	"./pl": 155,
	"./pl.js": 155,
	"./pt": 157,
	"./pt-br": 156,
	"./pt-br.js": 156,
	"./pt.js": 157,
	"./ro": 158,
	"./ro.js": 158,
	"./ru": 159,
	"./ru.js": 159,
	"./sd": 160,
	"./sd.js": 160,
	"./se": 161,
	"./se.js": 161,
	"./si": 162,
	"./si.js": 162,
	"./sk": 163,
	"./sk.js": 163,
	"./sl": 164,
	"./sl.js": 164,
	"./sq": 165,
	"./sq.js": 165,
	"./sr": 167,
	"./sr-cyrl": 166,
	"./sr-cyrl.js": 166,
	"./sr.js": 167,
	"./ss": 168,
	"./ss.js": 168,
	"./sv": 169,
	"./sv.js": 169,
	"./sw": 170,
	"./sw.js": 170,
	"./ta": 171,
	"./ta.js": 171,
	"./te": 172,
	"./te.js": 172,
	"./tet": 173,
	"./tet.js": 173,
	"./tg": 174,
	"./tg.js": 174,
	"./th": 175,
	"./th.js": 175,
	"./tk": 176,
	"./tk.js": 176,
	"./tl-ph": 177,
	"./tl-ph.js": 177,
	"./tlh": 178,
	"./tlh.js": 178,
	"./tr": 179,
	"./tr.js": 179,
	"./tzl": 180,
	"./tzl.js": 180,
	"./tzm": 182,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 182,
	"./ug-cn": 183,
	"./ug-cn.js": 183,
	"./uk": 184,
	"./uk.js": 184,
	"./ur": 185,
	"./ur.js": 185,
	"./uz": 187,
	"./uz-latn": 186,
	"./uz-latn.js": 186,
	"./uz.js": 187,
	"./vi": 188,
	"./vi.js": 188,
	"./x-pseudo": 189,
	"./x-pseudo.js": 189,
	"./yo": 190,
	"./yo.js": 190,
	"./zh-cn": 191,
	"./zh-cn.js": 191,
	"./zh-hk": 192,
	"./zh-hk.js": 192,
	"./zh-mo": 193,
	"./zh-mo.js": 193,
	"./zh-tw": 194,
	"./zh-tw.js": 194
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76a16e9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("支付")]), _vm._v(" "), _c('mt-button', {
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v("授权")]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/ticket/once"
    }
  }, [_vm._v("购票")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/order/all"
    }
  }, [_vm._v("我的订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coupon/gift"
    }
  }, [_vm._v("我的卡券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/myNewActivity"
    }
  }, [_vm._v("我的活动")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/activityList"
    }
  }, [_vm._v("活动列表")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/information"
    }
  }, [_vm._v("资讯列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coach/grade"
    }
  }, [_vm._v("教练列表")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rights"
    }
  }, [_vm._v("会员权益")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/mine"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("绑定手机号")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/getCoupon/1"
    }
  }, [_vm._v("领券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/userInfo"
    }
  }, [_vm._v("个人信息")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/error"
    }
  }, [_vm._v("Error")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/course"
    }
  }, [_vm._v("购课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/orderBill/1"
    }
  }, [_vm._v("电子小票")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/myCourse/open"
    }
  }, [_vm._v("我的课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/subscribedCourse"
    }
  }, [_vm._v("已约课程")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/startedCourse"
    }
  }, [_vm._v("已上课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/subscribeCourse"
    }
  }, [_vm._v("预约课程")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/subscribeExperienceCourse"
    }
  }, [_vm._v("预约体验课")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/coursePay"
    }
  }, [_vm._v("课程支付")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/chooseCourse"
    }
  }, [_vm._v("选择课程")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "fixed-2"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);



// 购票
var Ticket = function Ticket(r) {
  return __webpack_require__.e/* require.ensure */(73).then((function () {
    return r(__webpack_require__(370));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Once = function Once(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(367));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Period = function Period(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(368));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Exercise = function Exercise(r) {
  return __webpack_require__.e/* require.ensure */(54).then((function () {
    return r(__webpack_require__(366));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UseCoupon = function UseCoupon(r) {
  return __webpack_require__.e/* require.ensure */(41).then((function () {
    return r(__webpack_require__(371));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ShopTips = function ShopTips(r) {
  return __webpack_require__.e/* require.ensure */(74).then((function () {
    return r(__webpack_require__(369));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 购票订单确认
var Confirm = function Confirm(r) {
  return __webpack_require__.e/* require.ensure */(31).then((function () {
    return r(__webpack_require__(365));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var BuyRenew = function BuyRenew(r) {
  return __webpack_require__.e/* require.ensure */(23).then((function () {
    return r(__webpack_require__(364));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 我的订单
var Order = function Order(r) {
  return __webpack_require__.e/* require.ensure */(76).then((function () {
    return r(__webpack_require__(356));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderAll = function OrderAll(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__(357));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderPay = function OrderPay(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(361));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderRefund = function OrderRefund(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(362));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderDone = function OrderDone(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(360));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderDetail = function OrderDetail(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__(359));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderBill = function OrderBill(r) {
  return __webpack_require__.e/* require.ensure */(52).then((function () {
    return r(__webpack_require__(358));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 活动核销码
var OrderVerify = function OrderVerify(r) {
  return __webpack_require__.e/* require.ensure */(53).then((function () {
    return r(__webpack_require__(377));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var VerifyCode = function VerifyCode(r) {
  return __webpack_require__.e/* require.ensure */(57).then((function () {
    return r(__webpack_require__(378));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的卡券
var Coupon = function Coupon(r) {
  return __webpack_require__.e/* require.ensure */(89).then((function () {
    return r(__webpack_require__(305));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GiftCoupon = function GiftCoupon(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__(309));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CashCoupon = function CashCoupon(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__(304));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseCoupon = function CourseCoupon(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__(307));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CouponDetail = function CouponDetail(r) {
  return __webpack_require__.e/* require.ensure */(58).then((function () {
    return r(__webpack_require__(306));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GetCoupon = function GetCoupon(r) {
  return __webpack_require__.e/* require.ensure */(61).then((function () {
    return r(__webpack_require__(308));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的活动
var Activity = function Activity(r) {
  return __webpack_require__.e/* require.ensure */(92).then((function () {
    return r(__webpack_require__(288));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Verify = function Verify(r) {
  return __webpack_require__.e/* require.ensure */(48).then((function () {
    return r(__webpack_require__(294));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActivityDone = function ActivityDone(r) {
  return __webpack_require__.e/* require.ensure */(49).then((function () {
    return r(__webpack_require__(292));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActivityDetail = function ActivityDetail(r) {
  return __webpack_require__.e/* require.ensure */(39).then((function () {
    return r(__webpack_require__(291));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 活动列表
var ActivityList = function ActivityList(r) {
  return __webpack_require__.e/* require.ensure */(50).then((function () {
    return r(__webpack_require__(290));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ActivityListDetail = function ActivityListDetail(r) {
  return __webpack_require__.e/* require.ensure */(56).then((function () {
    return r(__webpack_require__(289));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EnterWay = function EnterWay(r) {
  return __webpack_require__.e/* require.ensure */(91).then((function () {
    return r(__webpack_require__(293));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 资讯列表
var Information = function Information(r) {
  return __webpack_require__.e/* require.ensure */(43).then((function () {
    return r(__webpack_require__(331));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var InformationDetail = function InformationDetail(r) {
  return __webpack_require__.e/* require.ensure */(83).then((function () {
    return r(__webpack_require__(330));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教练列表
var Coach = function Coach(r) {
  return __webpack_require__.e/* require.ensure */(90).then((function () {
    return r(__webpack_require__(297));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoachGrade = function CoachGrade(r) {
  return __webpack_require__.e/* require.ensure */(38).then((function () {
    return r(__webpack_require__(299));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoachScore = function CoachScore(r) {
  return __webpack_require__.e/* require.ensure */(36).then((function () {
    return r(__webpack_require__(302));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoachYear = function CoachYear(r) {
  return __webpack_require__.e/* require.ensure */(35).then((function () {
    return r(__webpack_require__(303));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoachLimits = function CoachLimits(r) {
  return __webpack_require__.e/* require.ensure */(37).then((function () {
    return r(__webpack_require__(301));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoachDetail = function CoachDetail(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__(298));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Judge = function Judge(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__(300));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 会员权益
var Rights = function Rights(r) {
  return __webpack_require__.e/* require.ensure */(32).then((function () {
    return r(__webpack_require__(337));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Explain = function Explain(r) {
  return __webpack_require__.e/* require.ensure */(44).then((function () {
    return r(__webpack_require__(334));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 个人中心
var Mine = function Mine(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__(335));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 剩余基础课节
var BaseCourse = function BaseCourse(r) {
  return __webpack_require__.e/* require.ensure */(82).then((function () {
    return r(__webpack_require__(332));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseCarConsumeRecord = function CourseCarConsumeRecord(r) {
  return __webpack_require__.e/* require.ensure */(81).then((function () {
    return r(__webpack_require__(333));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 时段票用时明细
var PeriodDetail = function PeriodDetail(r) {
  return __webpack_require__.e/* require.ensure */(45).then((function () {
    return r(__webpack_require__(336));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 绑定手机号
var Bind = function Bind(r) {
  return __webpack_require__.e/* require.ensure */(67).then((function () {
    return r(__webpack_require__(295));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Login = function Login(r) {
  return __webpack_require__.e/* require.ensure */(66).then((function () {
    return r(__webpack_require__(296));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 个人信息
var UserInfo = function UserInfo(r) {
  return __webpack_require__.e/* require.ensure */(68).then((function () {
    return r(__webpack_require__(376));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Unregister = function Unregister(r) {
  return __webpack_require__.e/* require.ensure */(69).then((function () {
    return r(__webpack_require__(375));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SetName = function SetName(r) {
  return __webpack_require__.e/* require.ensure */(71).then((function () {
    return r(__webpack_require__(373));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SetSchool = function SetSchool(r) {
  return __webpack_require__.e/* require.ensure */(70).then((function () {
    return r(__webpack_require__(374));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SetBirth = function SetBirth(r) {
  return __webpack_require__.e/* require.ensure */(72).then((function () {
    return r(__webpack_require__(372));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 错误页面
var Error = function Error(r) {
  return __webpack_require__.e/* require.ensure */(64).then((function () {
    return r(__webpack_require__(329));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 课程
var Course = function Course(r) {
  return __webpack_require__.e/* require.ensure */(22).then((function () {
    return r(__webpack_require__(314));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseCardDetail = function CourseCardDetail(r) {
  return __webpack_require__.e/* require.ensure */(51).then((function () {
    return r(__webpack_require__(315));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoursePackage = function CoursePackage(r) {
  return __webpack_require__.e/* require.ensure */(65).then((function () {
    return r(__webpack_require__(316));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PictureInfo = function PictureInfo(r) {
  return __webpack_require__.e/* require.ensure */(88).then((function () {
    return r(__webpack_require__(319));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Experience = function Experience(r) {
  return __webpack_require__.e/* require.ensure */(47).then((function () {
    return r(__webpack_require__(317));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ChooseTime = function ChooseTime(r) {
  return __webpack_require__.e/* require.ensure */(29).then((function () {
    return r(__webpack_require__(312));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ChooseCoach = function ChooseCoach(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__(311));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ConfirmOrder = function ConfirmOrder(r) {
  return __webpack_require__.e/* require.ensure */(28).then((function () {
    return r(__webpack_require__(313));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrderStatus = function OrderStatus(r) {
  return __webpack_require__.e/* require.ensure */(60).then((function () {
    return r(__webpack_require__(318));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CardTicket = function CardTicket(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__(310));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的课程
var MyCourse = function MyCourse(r) {
  return __webpack_require__.e/* require.ensure */(80).then((function () {
    return r(__webpack_require__(338));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Open = function Open(r) {
  return __webpack_require__.e/* require.ensure */(25).then((function () {
    return r(__webpack_require__(342));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var NotOpen = function NotOpen(r) {
  return __webpack_require__.e/* require.ensure */(33).then((function () {
    return r(__webpack_require__(341));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseDone = function CourseDone(r) {
  return __webpack_require__.e/* require.ensure */(34).then((function () {
    return r(__webpack_require__(340));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseTable = function CourseTable(r) {
  return __webpack_require__.e/* require.ensure */(79).then((function () {
    return r(__webpack_require__(339));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用时明细
var UseTime = function UseTime(r) {
  return __webpack_require__.e/* require.ensure */(78).then((function () {
    return r(__webpack_require__(343));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 添加支付页面
var Pay = function Pay(r) {
  return __webpack_require__.e/* require.ensure */(75).then((function () {
    return r(__webpack_require__(363));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的二维票
var Note = function Note(r) {
  return __webpack_require__.e/* require.ensure */(77).then((function () {
    return r(__webpack_require__(352));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CourseNote = function CourseNote(r) {
  return __webpack_require__.e/* require.ensure */(40).then((function () {
    return r(__webpack_require__(351));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OnceNote = function OnceNote(r) {
  return __webpack_require__.e/* require.ensure */(30).then((function () {
    return r(__webpack_require__(354));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PeriodNote = function PeriodNote(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__(355));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CompanyNote = function CompanyNote(r) {
  return __webpack_require__.e/* require.ensure */(42).then((function () {
    return r(__webpack_require__(350));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var NoteDetail = function NoteDetail(r) {
  return __webpack_require__.e/* require.ensure */(59).then((function () {
    return r(__webpack_require__(353));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 新活动
var NewActivity = function NewActivity(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__(345));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var NewConfirm = function NewConfirm(r) {
  return __webpack_require__.e/* require.ensure */(63).then((function () {
    return r(__webpack_require__(344));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ShopDetail = function ShopDetail(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__(349));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MyNewActivity = function MyNewActivity(r) {
  return __webpack_require__.e/* require.ensure */(24).then((function () {
    return r(__webpack_require__(347));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RegisDetail = function RegisDetail(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__(348));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var HtmlWrap = function HtmlWrap(r) {
  return __webpack_require__.e/* require.ensure */(62).then((function () {
    return r(__webpack_require__(346));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/ticket',
    name: 'Ticket',
    component: Ticket,
    children: [{
      path: 'once',
      component: Once,
      meta: {
        title: '单次票'
      }
    }, {
      path: 'period',
      component: Period,
      meta: {
        title: '时段票'
      }
    }, {
      path: 'exercise',
      component: Exercise,
      meta: {
        title: '练习票'
      }
    }]
  }, {
    path: '/ticket/buyRenew',
    component: BuyRenew,
    meta: {
      title: '延时续场缴费'
    }
  }, {
    path: '/useCoupon/:oid',
    name: 'UseCoupon',
    component: UseCoupon,
    meta: {
      title: '使用卡券'
    }
  }, {
    path: '/shopTips',
    name: 'ShopTips',
    component: ShopTips
  }, {
    path: '/confirm/:oid/:mid/:type',
    name: 'Confirm',
    component: Confirm,
    mate: {
      title: '订单确认'
    }
  }, {
    path: '/order',
    name: 'Order',
    component: Order,
    children: [{
      path: 'all',
      component: OrderAll
    }, {
      path: 'pay',
      component: OrderPay
    }, {
      path: 'refund',
      component: OrderRefund
    }, {
      path: 'done',
      component: OrderDone
    }]
  }, {
    path: '/order/:oid',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    children: [{
      path: 'gift',
      component: GiftCoupon
    }, {
      path: 'course',
      component: CourseCoupon
    }, {
      path: 'cash',
      component: CashCoupon
    }]
  }, {
    path: '/couponDetail/:cid',
    name: 'CouponDetail',
    component: CouponDetail
  }, {
    path: '/getCoupon/:cid',
    name: 'GetCoupon',
    component: GetCoupon
  }, {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    children: [{
      path: 'verify',
      component: Verify
    }, {
      path: 'done',
      component: ActivityDone
    }]
  }, {
    path: '/activityDetail/:aid',
    name: 'ActivityDetail',
    component: ActivityDetail
  }, {
    path: '/activityList',
    name: 'ActivityList',
    component: ActivityList,
    meta: {
      title: '活动列表'
    }
  }, {
    path: '/activityList/:aid',
    name: 'ActivityListDetail',
    component: ActivityListDetail
  }, {
    path: '/enterWay/:eid',
    name: 'EnterWay',
    component: EnterWay
  }, {
    path: '/information',
    name: 'Information',
    component: Information
  }, {
    path: '/information/:iid',
    name: 'InformationDetail',
    component: InformationDetail
  }, {
    path: '/coach',
    name: 'Coach',
    component: Coach,
    children: [{
      path: 'grade',
      component: CoachGrade
    }, {
      path: 'score',
      component: CoachScore
    }, {
      path: 'years',
      component: CoachYear
    }, {
      path: 'limits',
      component: CoachLimits
    }]
  }, {
    path: '/coachDetail/:cid',
    name: 'CoachDetail',
    component: CoachDetail
  }, {
    path: '/judge/:cid',
    name: 'Judge',
    component: Judge
  }, {
    path: '/rights',
    name: 'Rights',
    component: Rights
  }, {
    path: '/explain',
    name: 'Explain',
    component: Explain
  }, {
    path: '/mine',
    name: 'Mine',
    component: Mine
  }, {
    path: '/baseCourse',
    name: 'BaseCourse',
    component: BaseCourse
  }, {
    path: '/courseCarConsumeRecord',
    name: 'CourseCarConsumeRecord',
    component: CourseCarConsumeRecord
  }, {
    path: '/periodDetail/:pid/:left',
    name: 'PeriodDetail',
    component: PeriodDetail
  }, {
    path: '/bind',
    name: 'Bind',
    component: Bind
  }, {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfo
  }, {
    path: '/unregister',
    name: 'Unregister',
    component: Unregister
  }, {
    path: '/error',
    name: 'Error',
    component: Error
  }, {
    path: '/setName',
    name: 'SetName',
    component: SetName
  }, {
    path: '/setSchool',
    name: 'SetSchool',
    component: SetSchool
  }, {
    path: '/setBirth',
    name: 'SetBirth',
    component: SetBirth
  }, {
    path: '/course',
    name: 'Course',
    component: Course
  }, {
    path: '/courseCardDetail/:id',
    name: 'CourseCardDetail',
    component: CourseCardDetail
  }, {
    path: '/coursePackage/:cid',
    name: 'CoursePackage',
    component: CoursePackage
  }, {
    path: '/pictureInfo/:pid',
    name: 'PictureInfo',
    component: PictureInfo
  }, {
    path: '/experience/:eid',
    name: 'Experience',
    component: Experience
  }, {
    path: '/chooseTime',
    name: 'ChooseTime',
    component: ChooseTime
  }, {
    path: '/chooseCoach',
    name: 'ChooseCoach',
    component: ChooseCoach
  }, {
    path: '/confirmOrder',
    name: 'ConfirmOrder',
    component: ConfirmOrder
  }, {
    path: '/orderStatus',
    name: 'OrderStatus',
    component: OrderStatus
  }, {
    path: '/cardTicket',
    name: 'CardTicket',
    component: CardTicket
  }, {
    path: '/orderBill/:oid',
    name: 'OrderBill',
    component: OrderBill
  }, {
    path: '/myCourse',
    name: 'MyCourse',
    component: MyCourse,
    children: [{
      path: 'open',
      name: 'Open',
      component: Open,
      meta: {
        title: '我的课程'
      }
    }, {
      path: 'notOpen',
      name: 'NotOpen',
      component: NotOpen,
      meta: {
        title: '我的课程'
      }
    }, {
      path: 'done',
      name: 'Done',
      component: CourseDone,
      meta: {
        title: '我的课程'
      }
    }]
  }, {
    path: '/courseTable/:courseId/:courseMemberId/:courseNum/:courseNumLeft/:courseEndTime',
    name: 'CourseTable',
    component: CourseTable
  }, {
    path: '/useTime/:uid',
    name: 'UseTime',
    component: UseTime
  }, {
    path: '/pay/:oid',
    name: 'Pay',
    component: Pay
  }, {
    path: '/note',
    name: 'Note',
    component: Note,
    children: [{
      path: 'course',
      name: 'Course',
      component: CourseNote
    }, {
      path: 'once',
      name: 'Once',
      component: OnceNote
    }, {
      path: 'period',
      name: 'Period',
      component: PeriodNote
    }, {
      path: 'company',
      name: 'Company',
      component: CompanyNote
    }]
  }, {
    path: '/noteDetail',
    name: 'NoteDetail',
    component: NoteDetail
  }, {
    path: '/newActivity/:aid',
    name: 'NewActivity',
    component: NewActivity
  }, {
    path: '/newConfirm',
    name: 'NewConfirm',
    component: NewConfirm
  }, {
    path: '/shopDetail/:aid',
    name: 'ShopDetail',
    component: ShopDetail
  }, {
    path: '/myNewActivity',
    name: 'MyNewActivity',
    component: MyNewActivity
  }, {
    path: '/regisDetail/:aid/:code',
    name: 'RegisDetail',
    component: RegisDetail
  }, {
    path: '/htmlwrap/:aid',
    name: 'HtmlWrap',
    component: HtmlWrap
  }, {
    path: '/orderVerify/:oid/:aid/:eid',
    name: 'OrderVerify',
    component: OrderVerify
  }, {
    path: '/verifyCode',
    name: 'VerifyCode',
    component: VerifyCode
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/coachDate',
    component: function component() {
      return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 287));
    }
  }, {
    path: '/subscribeCourse',
    name: 'SubscribeCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 217));
    }
  }, {
    path: '/subscribeExperienceCourse',
    name: 'SubscribeExperienceCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 217));
    }
  }, {
    path: '/subscribeTypes',
    name: 'SubscribeTypes',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 325));
    }
  }, {
    path: '/coachArrange',
    name: 'CoachArrange',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 321));
    }
  }, {
    path: '/courseInformation',
    name: 'CourseInformation',
    component: function component() {
      return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 322));
    }
  }, {
    path: '/subscribedCourse',
    name: 'SubscribedCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 328));
    }
  }, {
    path: '/startedCourse',
    name: 'StartedCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 327));
    }
  }, {
    path: '/cancelSubscibedCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 326));
    }
  }, {
    path: '/courseOrderConfirm',
    component: function component() {
      return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 323));
    }
  }, {
    path: '/coursePay',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 324));
    }
  }, {
    path: '/chooseCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 320));
    }
  }]
}));

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(33);


var Utils = {
  GetQueryString: function GetQueryString(hash, name) {
    hash = hash || '';
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = hash.substr(1).match(reg);
    if (r != null) {
      return decodeURI(r[2]);
    }
    return null;
  },
  CountTime: function CountTime(val) {
    var timer = setInterval(function () {
      var h = Math.floor(val / 60 / 60);
      var m = Math.floor((val - h * 60 * 60) / 60);
      var s = Math.floor(val - h * 60 * 60 - m * 60);
      if (val < 0) {
        clearInterval(timer);
      } else {
        return h + ':' + m + ':' + s;
      }
      val--;
    }, 1000);
  },
  setTitle: function setTitle(val) {
    document.title = val;
  },
  buttonPermissions: function buttonPermissions() {
    var wxUserStatus = sessionStorage.getItem('wxUserStatus');
    if (wxUserStatus === '1') {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/bind');
      return false;
    } else if (wxUserStatus === '2') {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/login');
      return false;
    }
    return true;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2017/6/3 0003.
 * 管理api环境切换
 */
// 生产环境已全部切换为https
var url = location.href;
var protocol = location.href.split('://')[0];
var apiObj = void 0;
if (protocol === 'https') {
  if (url.indexOf("wiadev.crland.com.cn") > -1) {
    apiObj = {
      // api: '/wx/'
      // api: 'http://192.168.31.253/'
      // 测试环境
      api: 'https://wiadev.crland.com.cn/',
      payUrl: 'https://wiadev.crland.com.cn/wechat/index.html#/pay/',
      // 上传附件
      fileUploadUrl: 'fileapi/icefile/upload.do'
    };
  } else {
    apiObj = {
      // api: '/wx/'
      // api: 'http://192.168.31.253/'
      // 生产环境
      api: 'https://wia.crland.com.cn/',
      payUrl: 'https://wia.crland.com.cn/wechat/index.html#/pay/',
      // 上传附件
      fileUploadUrl: 'fileapi/icefile/upload.do'
    };
  }
} else {
  apiObj = {
    api: '/wx/',
    // api: 'http://192.168.31.253/'
    // 测试环境
    // api: 'http://wiadev.crland.com.cn/',
    // payUrl: 'http://wiadev.crland.com.cn/wechat/index.html#/pay/'
    // 生产环境
    // api: 'http://wia.crland.com.cn/',
    // payUrl: 'http://wia.crland.com.cn/wechat/index.html#/pay/'
    // 上传附件
    fileUploadUrl: 'fileapi/icefile/upload.do'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (apiObj);

/***/ })

},[237]);


// WEBPACK FOOTER //
// static/js/app.31b2b707bb353982ef96.js